import React, { useEffect, useState } from 'react';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as MinusIcon } from 'assets/icons/minus.svg';
import useDashboardContext from 'contexts/dashboard.context';
import { ROUTE_KEYS } from 'utils/constants';
import FAQs from './faq.json';

const FaqPage = () => {
  const [openFaq, setOpenFaq] = useState(0);
  const [toggle, setToggle] = useState(false);
  const { setIsBackLink, setBackLink, setBackLinkTitle } = useDashboardContext();

  const handleToggle = (idx: number, open?: boolean) => {
    //  openFaq becomes prev idx before updating
    setToggle((prev) => (open ?? openFaq === idx ? !prev : true));

    setOpenFaq(idx);
  };

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to support');
    setBackLink(`/${ROUTE_KEYS.SUPPORT}`);
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
      setBackLink('');
    };
  }, []);

  return (
    <div className='flex flex-col lg:flex-row items-start gap-10'>
      <h1 className='w-full lg:w-[40%] text-[48px] leading-[60px] font-semibold'>
        Have Questions? Check here.
      </h1>
      <ul className='w-full lg:w-[60%] flex flex-col rounded-2xl bg-[#F8FAFB] overflow-hidden'>
        {FAQs.map((faq, index) => (
          <li
            key={index}
            className={`flex items-start gap-4 px-10 py-4 transition-all ${
              index === openFaq ? 'bg-[#F3F3F3]' : ''
            }`}>
            <div className='flex flex-col gap-3'>
              <p
                onClick={() => handleToggle(index)}
                className='max-w-[445px] text-xl font-medium cursor-pointer select-none'>
                {faq.question}
              </p>
              {index === openFaq && toggle ? <p className='text-lg'>{faq.answer}</p> : null}
            </div>
            <button className='shrink-0 w-6 h-6 ml-auto'>
              {index === openFaq && toggle ? (
                <MinusIcon className='w-6 h-6' onClick={() => handleToggle(index, true)} />
              ) : (
                <PlusIcon className='w-6 h-6' onClick={() => handleToggle(index, false)} />
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FaqPage;
